import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontWeights,
  breakpoints,
  palette,
}: Theme) => ({
  list: {
    [breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '4rem',
    height: '4rem',
    borderRadius: '50%',
    backgroundColor: palette.info.light,
  },
  iconText: {
    width: '2.5rem',
    height: '2.5rem',
    backgroundColor: palette.secondary.dark,
    color: palette.common.white,
    fontWeight: fontWeights.medium,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    [breakpoints.up('md')]: {
      padding: '0.75rem 1.5rem',
      border: `2px solid ${palette.info.light}`,
      borderRadius: '0.75rem',
    },
  },
}));
